<template>
  <div>
    <Header ref="header" @query="getData"/>
    <TemplateCard
      v-loading="loading"
      :data="data"
      @confirm="(e) => $emit('confirm', e)"
    />
    <div class="d-flex justify-content-between mt-3 mb-2">
      <pagination
        size="small"
        align="right"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="onPaginationChange"
      />
      <div class="d-flex justify-content-center align-items-center">
        <el-button size="small" @click="$emit('close')">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import TemplateCard from './template-card.vue'
import Header from './header'
export default {
  components: { TemplateCard, Header },
  props: {
    templateGroup: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
      page: { curPage: 1, pageSize: 20, pageTotal: 0 },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    async getData(form) {
      if (!this.templateGroup) {
        throw new Error('props [templateGroup] is null')
      }

      const params = {
        templateGroup: this.templateGroup,
        ...this.page,
        ...form,
        custCode: this.custCode,
      }
      this.loading = true
      const res = await this.$api
        .sysCustomerExportTemplateListApi(params)
        .catch(() => null)
      this.loading = false
      if (!res || !res.body) return
      this.data = res.body.data
      this.page.pageTotal = res.body.count
      this.page.pageSize = res.body.pageSize
      this.page.curPage = res.body.curPage
    },
    onPaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.query()
    },
    confirm(data) {
      this.$emit('confirm', data)
    },
    query() {
      this.$refs.header.query()
    }
  },
}
</script>
